import { render, staticRenderFns } from "./IPsettings.vue?vue&type=template&id=4c7a63dc&scoped=true"
import script from "./IPsettings.vue?vue&type=script&lang=js"
export * from "./IPsettings.vue?vue&type=script&lang=js"
import style0 from "./IPsettings.vue?vue&type=style&index=0&id=4c7a63dc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7a63dc",
  null
  
)

export default component.exports